import React, { useState } from "react";
import Button from "./Button";

/**
 * Bottom-sheet modal that lets a memorial owner choose (or create) a pinned
 * memory note. Supports selecting an existing note or writing a new one.
 */
export default function PinNoteSheet({
  availableNotes,
  initialNoteId,
  onSave,
  onClose,
}) {
  const [selectedNoteId, setSelectedNoteId] = useState(initialNoteId);
  const [creatingNew, setCreatingNew] = useState(false);
  const [newText, setNewText] = useState("");
  const [newAuthor, setNewAuthor] = useState("Admin");

  const handleSave = () => {
    if (creatingNew) {
      if (!newText.trim()) return;
      onSave({ type: "new", text: newText.trim(), authorName: newAuthor || "Admin" });
    } else {
      onSave({ type: "existing", noteId: selectedNoteId });
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 bg-black/40 flex items-end justify-center"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="bg-white w-full rounded-t-[20px] max-h-[80vh] overflow-hidden">
        <div className="sticky top-0 z-10 bg-white">
          <div className="flex items-center justify-between p-4 border-b border-[rgba(0,0,0,0.06)]">
            <div className="text-[16px] font-semibold">Choose one</div>
            <div className="flex items-center gap-2">
              <Button onClick={onClose}>Cancel</Button>
              <Button onClick={handleSave}>Save</Button>
            </div>
          </div>
        </div>

        <div className="p-4 overflow-y-auto" style={{ maxHeight: "calc(80vh - 60px)" }}>
          <div className="mb-3">
            <Button onClick={() => setCreatingNew((v) => !v)}>
              {creatingNew ? "Choose existing" : "Create new"}
            </Button>
          </div>

          {creatingNew ? (
            <div className="space-y-2">
              <textarea
                className="w-full border rounded p-2"
                rows={5}
                placeholder="Write new memory note..."
                value={newText}
                onChange={(e) => setNewText(e.target.value)}
              />
              <input
                className="w-full border rounded p-2"
                placeholder="Author name"
                value={newAuthor}
                onChange={(e) => setNewAuthor(e.target.value)}
              />
            </div>
          ) : (
            <div className="flex flex-col gap-3">
              {availableNotes.map((n) => (
                <button
                  key={n.id}
                  onClick={() => setSelectedNoteId(n.id)}
                  className={`text-left w-full rounded-[20px] border ${
                    selectedNoteId === n.id
                      ? "border-[#44231E] ring-2 ring-[#44231E]"
                      : "border-[rgba(0,0,0,0.06)]"
                  } p-4`}
                >
                  <div className="text-xs text-[#ADADAD] mb-2">
                    {n.createdAt?.toDate
                      ? new Date(n.createdAt.toDate()).toLocaleDateString("da-DK", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "2-digit",
                        })
                      : ""}
                  </div>
                  <div className="text-[14px] whitespace-pre-line">
                    {(n.text || "").slice(0, 280)}
                  </div>
                  <div className="mt-2 text-xs text-[#ADADAD]">
                    {(n.authorName === "Anonym" ? "Anonymous" : n.authorName) ||
                      "Anonymous"}
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
